module.exports = __webpack_public_path__ + "static/media/fit-branco.d7f8dd32.jpg";